module.exports = __webpack_public_path__ + "static/img/phone-barCode.0c002f1d.png";